import React from "react";
import testi1 from './images/Saumya.png';
import testi2 from './images/simran.png';
import testi3 from './images/sonam.png';

function CourseTestimonial (){
    return (
        <section className="py-5 classroom-card mt-5">
            <div className="container bg-white p-5">
                <div className="text-center mb-4">
                    <h4 className="fw-bold">Reason Why Student Love and Prefer VIGYAN VRIKSH</h4>
                </div>
                <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="testimonial-card">
                                <img src={testi1} className="testimonial-img" alt="User" />
                                <h5 className="testimonial-name">Saumya</h5>
                                <p className="testimonial-title">CSIR NET</p>
                                <p className="testimonial-text">I joined Vigyan Vriksh after CSIR NET June 2024. Joining Vigyan Vriksh was one of the best decisions. The content, question practice, and test series are inimitable. I will personally suggest joining Vigyan Vriksh if you are preparing for NET/GATE.</p>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="testimonial-card">
                                <img src={testi2} className="testimonial-img" alt="User" />
                                <h5 className="testimonial-name">Priya Sharma</h5>
                                <p className="testimonial-title">JEE 2023 (AIR 89)</p>
                                <p className="testimonial-text">If we talk about the expertise in the subject of chemistry then I always remind only one Name i.e Vigyan Vriksh followed by such an amazing team working like a family and this family decided to enlighten the life of many aspirants to achieve their goal and fulfill their Dreams . This beautiful family will always going to treat you as well ,as a member of their family . Thank you so much to the entire family of Vigyan Vriksh App for your commendable efforts .We are really greatful of yours.</p>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="testimonial-card">
                                <img src={testi3} className="testimonial-img" alt="User" />
                                <h5 className="testimonial-name">Sonam</h5>
                                <p className="testimonial-title">CSIR NET(AIR 30)</p>
                                <p className="testimonial-text">Vigyan Vriksh, name itself truly symbolizes its mission of spreading knowledge in the field of chemistry. Praveen Sir's teaching methodology is exceptional, building concepts from a foundational level to advanced topics, ensuring students gain a thorough understanding of the subject which really helped students of NET,GATE and IIT JAM examinations . Thank you, Praveen Sir, for your invaluable support!</p>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center gap-3 mt-4 testimonial-nav">
                        <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev"><i className="bi bi-arrow-left"></i></button>
                        <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next"><i className="bi bi-arrow-right"></i></button>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default CourseTestimonial;